import { render, staticRenderFns } from "./CreateAgent.vue?vue&type=template&id=bbf69c28&scoped=true"
import script from "./CreateAgent.vue?vue&type=script&lang=js"
export * from "./CreateAgent.vue?vue&type=script&lang=js"
import style0 from "./CreateAgent.vue?vue&type=style&index=0&id=bbf69c28&lang=css"
import style1 from "./CreateAgent.vue?vue&type=style&index=1&id=bbf69c28&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf69c28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbf69c28')) {
      api.createRecord('bbf69c28', component.options)
    } else {
      api.reload('bbf69c28', component.options)
    }
    module.hot.accept("./CreateAgent.vue?vue&type=template&id=bbf69c28&scoped=true", function () {
      api.rerender('bbf69c28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/agent/CreateAgent.vue"
export default component.exports